import MslpForm from './Mslp.form';
import BlogForm from './Blog.form';
import OtherForm from './Other.form';
import InventoryForm from './Inventory.form';
import { CONTENT_TYPE } from '../../../enums';
import { FEATURE_FLAGS, isFeatureEnabled } from '../../../utils/featureFlag';

const contentTypeForms = {
  [CONTENT_TYPE.MSLP.value]: MslpForm,
  [CONTENT_TYPE.BLOG.value]: BlogForm,
  [CONTENT_TYPE.INVENTORY.value]: InventoryForm,
  [CONTENT_TYPE.OTHER.value]: OtherForm
};
export const getFormComponent = (contentType) => {
  if (
    contentType === CONTENT_TYPE.INVENTORY.value &&
    !isFeatureEnabled(FEATURE_FLAGS.INVENTORY_PAGE)
  ) {
    return undefined;
  }

  return contentTypeForms[contentType];
};
